import React from 'react'

const AlertIcon = () => (
  <svg
    id="af1a9b7a-38a0-4017-87b5-f19615fc53dd"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
  >
    <title>Pending: Click to set time and confirm appointment</title>
    <path d="M28.28,3,10.6,15.44H.67V35.06H10.6L28.28,47.5ZM4.11,18.88h5.3V31.62H4.11Zm20.73,22-12-8.43V18.05l12-8.43Z" />
    <path d="M34.46,13.83,32,16.26a12.71,12.71,0,0,1,0,18l2.43,2.43a16.16,16.16,0,0,0,0-22.84Z" />
    <path d="M41.88,43.34a25.6,25.6,0,0,0,0-36.14L39.43,9.6a22.16,22.16,0,0,1,0,31.31Z" />
  </svg>
);

export default AlertIcon



// WEBPACK FOOTER //
// ./src/components/assets/AlertIcon.js